export const API_URL = "https://i.tysoft.com";
// export const API_URL = "http://localhost:8081";

//父页面域名
let htmlAnchorElement = document.createElement('a');
htmlAnchorElement.href = API_URL;

export const BASE_URL = htmlAnchorElement.origin;
